"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useRef, useState } from "react";
import { image as external_ImageVariants_js_image } from "./ImageVariants.js";
import { Skeleton } from "../Skeleton/index.js";
import { useSafeInView } from "../../hooks/index.js";
import { DEFAULT_IMAGE_URL } from "../../utils/index.js";
const Image = ({ src = DEFAULT_IMAGE_URL, alt, width, maxWidth, height, maxHeight, ratio, borderRadius, shadow, objectFit, objectPosition, isLoading, className, isSvg, lazyLoad = false, lazyRootMargin = '200px', lazyViewportRef, lazyForceLoad = false, showSkeletonWhileLoading = true, ...props })=>{
    const containerRef = useRef(null);
    const imageRef = useRef(null);
    const isInView = useSafeInView(lazyLoad ? containerRef : imageRef, {
        root: lazyViewportRef,
        margin: lazyRootMargin,
        once: true
    });
    const [shouldLoadImage, setShouldLoadImage] = useState(()=>!lazyLoad || lazyForceLoad);
    const [isImageLoaded, setIsImageLoaded] = useState(false);
    useEffect(()=>{
        if (lazyLoad && (lazyForceLoad || isInView)) setShouldLoadImage(true);
    }, [
        lazyLoad,
        lazyForceLoad,
        isInView
    ]);
    useEffect(()=>{
        setIsImageLoaded(false);
    }, [
        src
    ]);
    const handleImageLoad = useCallback(()=>{
        setIsImageLoaded(true);
    }, []);
    const classes = external_ImageVariants_js_image({
        width,
        maxWidth,
        height,
        maxHeight,
        ratio,
        borderRadius,
        shadow,
        objectFit,
        objectPosition,
        isLoading,
        className,
        isSvg
    });
    const combinedClasses = ratio ? `${classes} aspect-${ratio}` : classes;
    const showSkeleton = lazyLoad && (!shouldLoadImage || showSkeletonWhileLoading && !isImageLoaded);
    if (showSkeleton) return /*#__PURE__*/ jsxs("div", {
        ref: containerRef,
        className: combinedClasses,
        style: {
            aspectRatio: ratio
        },
        children: [
            /*#__PURE__*/ jsx(Skeleton, {
                type: "image",
                width: "100%",
                height: "100%",
                animate: true
            }),
            shouldLoadImage && /*#__PURE__*/ jsx("img", {
                ref: imageRef,
                src: src,
                alt: alt,
                onLoad: handleImageLoad,
                ...props,
                className: "hidden"
            })
        ]
    });
    return /*#__PURE__*/ jsx("img", {
        ref: imageRef,
        src: src,
        alt: alt,
        className: combinedClasses,
        onLoad: handleImageLoad,
        ...props,
        style: {
            aspectRatio: ratio
        },
        decoding: "async"
    });
};
export { Image };
